
import createHeaders from "@utils/createHeaders";

export const headers = createHeaders([
  { text: 'No', align: 'start', value: 'number_index', width: '10' },
  { text: 'Username', value: 'username', width: '50%'},
  { text: 'Role', value: 'role', width: '20%'},
  { text: 'Created At', value: 'created_at', width: '20%'},
  { text: 'Action', value: 'action',width: '10%'},
]);

export const search = {
  username: '',
  role: '',
  created_at: null,
};

